// extracted by mini-css-extract-plugin
export default {"selectbox":"wv_3kwQMXA9ipUgmkxjT"};